export abstract class AnimationsConfig {
  abstract animationsEnabled(): boolean;
  abstract backdropClass(): string | null;
}
